import { Button, StatusMessage } from '@aimsos/ui';
import { useTranslation } from '@aimsos/i18n';

import { Lock } from 'lucide-react';

/**
 * The resource exists; this user may not see it.
 *
 * Deliberately offers no retry — retrying does not grant access, and a retry
 * button here would invite the user to hammer a request that will keep failing.
 * Back is the only useful way out.
 */
function AccessDeniedState({ onBack }) {
  const { t } = useTranslation('unified-profiles');

  return (
    <div data-testid="access-denied-state" className="flex flex-1 flex-col items-center justify-center gap-6">
      <StatusMessage
        icon={Lock}
        title={t('states.accessDenied.title')}
        subtitle={t('states.accessDenied.subtitle')}
      />
      {onBack ? (
        <Button variant="secondary" size="medium" onClick={onBack}>
          {t('states.accessDenied.back')}
        </Button>
      ) : null}
    </div>
  );
}

export default AccessDeniedState;
